import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "react-bootstrap/Button";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import FldCloseIcon from "../images/round-close-icon.svg";

import ValidationAlertIcon from "../images/validation-alert-icon.svg";
import SparkleBigIcon from "../images/sparkle-big-icon.svg";
import HouseMobIcon from "../images/house-mob-icon.svg";
import NotifMobIcon from "../images/notif-mob-icon.svg";
import ClientbookMobIcon from "../images/clientbook-mob-icon.svg";
import UserMobIcon from "../images/user-mob-icon.svg";

import AppleIcon from "../components/appleIcn";

const SettingsApplePay = () => {
 


  return (
    <>
    <div className="gitcha-main-wrapper pb-102">
    <div className="content-wrapper content-wrapper-h-102">
    <div className="inner-layout-header-new bg-white">
    <div className="review-plan-header header-brdr-btm w-100">
      <div className="signup-login-header-top signup-header-txt clearfix">
          <a className="back-link-small" href="#"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z" fill="#1B1C1E"/>
</svg></a>

<span>Edit Plans</span> 
          

        </div>

        </div>
        </div>

        <div className="inner-layout-content-new h-100 bg-grey-variant">
         <div className="select-plan-wrap  min-h-100 clearfix">
      
        
    <div className="premium-content-wrapper">
    
          <div className="pro-premium-wrap">
          <div class="justify-content-between d-flex mb-2"><span className="titleSubhead">Your Plan</span><button type="button" class="btn btnTop">Cancel</button></div>
            <div className="pro-premium-innerwrap">
              
              <h4 className="d-flex align-items-center">Premium <img className="align-text-baseline mb-1" src={SparkleBigIcon} /></h4>
              <p>For optimizing features and saving on introductions</p>
            </div>
          </div>
          <div className="billing-cycle-wrap">
            <h4 className="mb-4">Billing Cycle</h4>
            <div className="billing-cycle-top border-bottom-0 pb-0">
            <label className="radio-wrap mb-1">
              <input type="radio" name="chk-mh56" id="bc21"/>
                <span>
                  <div className="billing-cycle-info">
                    <h2 className="pb-0">Annual ($12/month)</h2>
                  </div>
                </span>
            </label>
            <div className="bill-txt mb-32">$144 due today, then billed every year on April 15th</div>
            <label className="radio-wrap mb-1">
              <input type="radio" name="chk-mh56" id="bc11" />
                <span>
                  <div className="billing-cycle-info">
                    <h2 className="pb-0">Monthly ($15/month)</h2>
                  </div>
                </span>
            </label>
            <div className="bill-txt mb-1">$15 due today, then billed every month on the 15th</div>
            </div>
            
            </div>
            <div className="payment-method-wrap">
            <h4 className="mb-3">Payment Method</h4>

            <a className="txt-no-underline link-cursor mb-3 d-block">
              <div className="add-your-property-wrap mh-auto mb-0 brdr-rds-10 add-property-bg brdr-add-property">
                <div className="add-property-btn">
                <svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.53633 2.22231C4.81889 1.86889 5.01063 1.39435 4.96006 0.909424C4.54643 0.929991 4.04168 1.18231 3.74945 1.53601C3.48706 1.8389 3.25482 2.33331 3.31537 2.7979C3.77969 2.83818 4.24358 2.56581 4.53633 2.22231Z" fill="black"/>
  <path d="M4.95436 2.88868C4.28006 2.84851 3.70673 3.27138 3.38472 3.27138C3.06253 3.27138 2.56942 2.90892 2.03608 2.91869C1.34191 2.92888 0.697797 3.32137 0.345534 3.94562C-0.379011 5.19441 0.154327 7.04681 0.858909 8.06389C1.20107 8.56707 1.61343 9.1211 2.15678 9.1012C2.67016 9.08106 2.87138 8.76878 3.49541 8.76878C4.11898 8.76878 4.30024 9.1012 4.84368 9.09113C5.40724 9.08106 5.75956 8.5877 6.10172 8.08403C6.49424 7.51044 6.65492 6.95658 6.66503 6.92618C6.65492 6.91611 5.57833 6.5031 5.56835 5.26468C5.55818 4.22774 6.41359 3.73451 6.45385 3.70392C5.97079 2.98948 5.21603 2.90892 4.95436 2.88868Z" fill="black"/>
  <path d="M10.826 1.48535C12.2916 1.48535 13.3121 2.4956 13.3121 3.96643C13.3121 5.44252 12.2706 6.45801 10.7892 6.45801H9.16653V9.03854H7.99414V1.48535H10.826V1.48535ZM9.16653 5.47392H10.5118C11.5325 5.47392 12.1135 4.92437 12.1135 3.97168C12.1135 3.01909 11.5325 2.47469 10.517 2.47469H9.16653V5.47392Z" fill="black"/>
  <path d="M13.6182 7.47358C13.6182 6.51039 14.3562 5.91895 15.6649 5.84565L17.1723 5.7567V5.33275C17.1723 4.72031 16.7587 4.35391 16.0679 4.35391C15.4135 4.35391 15.0052 4.66791 14.9059 5.16H13.8381C13.9009 4.16541 14.7488 3.43262 16.1097 3.43262C17.4445 3.43262 18.2976 4.13926 18.2976 5.2437V9.03862H17.2141V8.13308H17.188C16.8688 8.74552 16.1725 9.13282 15.4502 9.13282C14.372 9.13282 13.6182 8.46282 13.6182 7.47358ZM17.1723 6.97634V6.54189L15.8165 6.62559C15.1413 6.67274 14.7593 6.97109 14.7593 7.44218C14.7593 7.92368 15.1571 8.23778 15.7642 8.23778C16.5546 8.23778 17.1723 7.69338 17.1723 6.97634Z" fill="black"/>
  <path d="M19.3208 11.0643V10.1482C19.4044 10.1691 19.5928 10.1691 19.6871 10.1691C20.2105 10.1691 20.4932 9.94933 20.6658 9.38403C20.6658 9.37353 20.7653 9.04904 20.7653 9.04379L18.7764 3.53198H20.0011L21.3935 8.01264H21.4143L22.8068 3.53198H24.0002L21.9377 9.32638C21.4668 10.6612 20.9224 11.0904 19.7814 11.0904C19.6871 11.0904 19.4044 11.0799 19.3208 11.0643Z" fill="black"/>
</svg>
                </div>
                <div className="make-intro-details pl-14">
                  <h4 className="mb-2">Apple Pay </h4>
                 
                </div>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.05806 3.30806C7.30214 3.06398 7.69786 3.06398 7.94194 3.30806L14.1919 9.55806C14.436 9.80214 14.436 10.1979 14.1919 10.4419L7.94194 16.6919C7.69786 16.936 7.30214 16.936 7.05806 16.6919C6.81398 16.4479 6.81398 16.0521 7.05806 15.8081L12.8661 10L7.05806 4.19194C6.81398 3.94786 6.81398 3.55214 7.05806 3.30806Z" fill="#000022"></path>
                  </svg>
              </div>
            </a>
        


            </div>

           
          


         
        </div>
         </div>

        
        </div>

    </div>

    <div className="inner-layout-footer-new">
                <div className="inner-btm-fixed-nav">
                    <div className="btn-wrap text-center pb-40 pt-0">
                        <button type="button" className="btn btn-iphone-pay w-100 mb-0" >Pay with  <AppleIcon/>  Pay</button>
                        
                    </div>
                 
                </div>
            </div>
        
        
     
    </div>
    </>
  );
};

export default SettingsApplePay;
